import { AWARDS } from "../data/content";
import { Reveal } from "./Reveal";
import { Award } from "lucide-react";

export const Awards = () => {
  return (
    <section
      id="awards"
      data-testid="awards-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Recognition
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              The shelf,
              <br />
              in chronological
              <br />
              order.
            </h2>

            <div className="mt-10 flex items-center gap-6">
              <img
                src="/top-vendor.jpg"
                alt="Shortlister Top Vendor 2020 Q4 — Health Risk Assessment"
                className="h-32 w-32 object-contain"
                loading="lazy"
              />
              <div>
                <div className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60 mb-1">
                  Q4 · 2020
                </div>
                <div className="font-serif text-xl text-[#0A192F] leading-tight">
                  Shortlister
                  <br />
                  Top Vendor
                </div>
                <div className="text-sm text-[#475569] mt-1">
                  Health Risk Assessment
                </div>
              </div>
            </div>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-7">
            <ul className="divide-y divide-[#0A192F]/10">
              {AWARDS.map((a, i) => (
                <li
                  key={a.title}
                  data-testid={`award-row-${i}`}
                  className="group py-7 lg:py-8 first:pt-0 grid grid-cols-[110px_1fr_auto] gap-4 lg:gap-8 items-baseline"
                >
                  <span className="font-serif text-[#0A192F]/40 ticker text-sm">
                    {a.year}
                  </span>
                  <div>
                    <h3 className="font-serif text-xl lg:text-2xl text-[#0A192F]">
                      {a.title}
                    </h3>
                    <p className="mt-1 text-sm text-[#475569]">{a.org}</p>
                  </div>
                  <Award className="text-[#0A192F]/40 group-hover:text-[#0A192F] transition-colors" size={20} />
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
